import { clsx } from 'clsx';
import { type ReactNode, forwardRef } from 'react';

import styles from './SpecialProjectCarouselLayout.css';

export type SpecialProjectCarouselLayoutProps = {
  carousel: ReactNode;
  builder: ReactNode;
  offersFewed: boolean;
};

export const SpecialProjectCarouselLayout = forwardRef<HTMLDivElement | null, SpecialProjectCarouselLayoutProps>(
  ({ builder, carousel, offersFewed }, ref) => {
    return (
      <div
        className={clsx(styles['container'], offersFewed && `carousel-offers-fewed`)}
        data-testid="SpecialProjectCarouselLayout"
        ref={ref}
      >
        <div className={styles['builder']}>{builder}</div>
        <div className={styles['carousel']}>{carousel}</div>
      </div>
    );
  },
);

SpecialProjectCarouselLayout.displayName = 'SpecialProjectCarouselLayout';
